export function formatStorageCapacity(capacityMB) {
  if (capacityMB === undefined || capacityMB === null || isNaN(capacityMB)) {
    return '0MB'
  }

  const capacity = Number(capacityMB)

  if (capacity === 0) {
    return '0MB'
  }

  if (capacity >= 1024) {
    const gb = Math.floor(capacity / 1024)
    const remainingMB = capacity % 1024

    if (remainingMB === 0) {
      return `${gb}GB`
    } else {
      // 修复浮点数精度问题，保留整数部分
      const remainingMBInt = Math.floor(remainingMB)
      return `${gb}G.${remainingMBInt}M`
    }
  }

  return `${Math.floor(capacity)}MB`
}

export function formatStorageCapacityWithDecimal(capacityMB, decimals = 1) {
  if (capacityMB === undefined || capacityMB === null || isNaN(capacityMB)) {
    return '0MB'
  }

  const capacity = Number(capacityMB)

  if (capacity === 0) {
    return '0MB'
  }

  if (capacity >= 1024) {
    const gb = capacity / 1024
    return `${gb.toFixed(decimals)}GB`
  }

  return `${Math.floor(capacity)}MB`
}
